module.exports = __webpack_public_path__ + "img/ico-delete.7929152a.svg";